(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
//   document.addEventListener("DOMContentLoaded", function () {
//   const track = document.querySelector('.testimonial-track');
//   let slides = Array.from(track.children);
//   const prevBtn = document.querySelector('.slider-nav.prev');
//   const nextBtn = document.querySelector('.slider-nav.next');
//   const dots = document.querySelectorAll('.slider-dot');

//   let slidesPerView = getSlidesPerView();
//   let currentIndex = slidesPerView; // start after cloned slides

//   // Clone slides for infinite effect
//   function cloneSlides() {
//     const firstClones = slides.slice(0, slidesPerView).map(s => s.cloneNode(true));
//     const lastClones = slides.slice(-slidesPerView).map(s => s.cloneNode(true));
//     firstClones.forEach(clone => track.appendChild(clone));
//     lastClones.reverse().forEach(clone => track.insertBefore(clone, track.firstChild));
//     slides = Array.from(track.children);
//   }

//   cloneSlides();
//   updateSlider(true);

//   function getSlidesPerView() {
//     const w = window.innerWidth;
//     if (w >= 1024) return 4;
//     if (w >= 768) return 2;
//     return 1;
//   }

//   function updateSlider(initial = false) {
//     slidesPerView = getSlidesPerView();
//     const slideWidthPercent = 100 / slidesPerView;
//     track.style.transition = initial ? 'none' : 'transform 0.6s ease-in-out';
//     track.style.transform = `translateX(-${currentIndex * slideWidthPercent}%)`;

//     // Update dots
//     const realIndex = (currentIndex - slidesPerView + slides.length) % (slides.length - slidesPerView*2);
//     dots.forEach(dot => dot.classList.remove('active'));
//     if (dots[realIndex]) dots[realIndex].classList.add('active');
//   }

//   function moveNext() {
//     currentIndex++; // move one slide
//     updateSlider();
//     if (currentIndex >= slides.length - slidesPerView) {
//       setTimeout(() => {
//         track.style.transition = 'none';
//         currentIndex = slidesPerView;
//         updateSlider(true);
//       }, 600);
//     }
//   }

//   function movePrev() {
//     currentIndex--; // move one slide
//     updateSlider();
//     if (currentIndex < slidesPerView) {
//       setTimeout(() => {
//         track.style.transition = 'none';
//         currentIndex = slides.length - slidesPerView*2;
//         updateSlider(true);
//       }, 600);
//     }
//   }

//   if (prevBtn) prevBtn.addEventListener('click', movePrev);
//   if (nextBtn) nextBtn.addEventListener('click', moveNext);

//   dots.forEach((dot, i) => {
//     dot.addEventListener('click', () => {
//       currentIndex = slidesPerView + i; // move one slide at a time
//       updateSlider();
//     });
//   });

//   window.addEventListener('resize', () => {
//     slidesPerView = getSlidesPerView();
//     updateSlider(true);
//   });

//   // Autoplay every 3 seconds (move one slide)
//   let autoplayInterval = setInterval(moveNext, 3000);

//   // Pause on hover
//   track.addEventListener('mouseenter', () => clearInterval(autoplayInterval));
//   track.addEventListener('mouseleave', () => autoplayInterval = setInterval(moveNext, 3000));
// });


document.addEventListener("DOMContentLoaded", function () {
  const track = document.querySelector('.testimonial-track');
  let slides = Array.from(track.children);
  const prevBtn = document.querySelector('.slider-nav.prev');
  const nextBtn = document.querySelector('.slider-nav.next');
  const dots = document.querySelectorAll('.slider-dot');

  let slidesPerView = getSlidesPerView();
  let currentIndex = slidesPerView; // start after cloned slides

  // Clone slides for infinite effect
  function cloneSlides() {
    const firstClones = slides.slice(0, slidesPerView).map(s => s.cloneNode(true));
    const lastClones = slides.slice(-slidesPerView).map(s => s.cloneNode(true));
    firstClones.forEach(clone => track.appendChild(clone));
    lastClones.reverse().forEach(clone => track.insertBefore(clone, track.firstChild));
    slides = Array.from(track.children);
  }

  cloneSlides();
  updateSlider(true);

  function getSlidesPerView() {
    const w = window.innerWidth;
    if (w >= 1024) return 4;
    if (w >= 768) return 2;
    return 1;
  }

  function updateSlider(initial = false) {
    slidesPerView = getSlidesPerView();
    const slideWidthPercent = 100 / slidesPerView;
    track.style.transition = initial ? 'none' : 'transform 0.6s ease-in-out';
    track.style.transform = `translateX(-${currentIndex * slideWidthPercent}%)`;

    // Update dots
    const realSlideCount = slides.length - slidesPerView * 2; // total original slides
    const realIndex = (currentIndex - slidesPerView + realSlideCount) % realSlideCount;
    dots.forEach(dot => dot.classList.remove('active'));
    if (dots[realIndex]) dots[realIndex].classList.add('active');
  }

  function moveNext() {
    currentIndex++; // move one slide
    updateSlider();
    if (currentIndex >= slides.length - slidesPerView) {
      setTimeout(() => {
        track.style.transition = 'none';
        currentIndex = slidesPerView;
        updateSlider(true);
      }, 600);
    }
  }

  function movePrev() {
    currentIndex--; // move one slide
    updateSlider();
    if (currentIndex < slidesPerView) {
      setTimeout(() => {
        track.style.transition = 'none';
        currentIndex = slides.length - slidesPerView * 2;
        updateSlider(true);
      }, 600);
    }
  }

  if (prevBtn) prevBtn.addEventListener('click', movePrev);
  if (nextBtn) nextBtn.addEventListener('click', moveNext);

  // Dot navigation: jump directly to the slide
  dots.forEach((dot, i) => {
    dot.addEventListener('click', () => {
      currentIndex = slidesPerView + i; // set index to correct slide including clone offset
      track.style.transition = 'transform 0.6s ease-in-out'; // ensure smooth transition
      updateSlider();
    });
  });

  window.addEventListener('resize', () => {
    slidesPerView = getSlidesPerView();
    updateSlider(true);
  });

  // Autoplay every 3 seconds
  let autoplayInterval = setInterval(moveNext, 3000);

  // Pause on hover
  track.addEventListener('mouseenter', () => clearInterval(autoplayInterval));
  track.addEventListener('mouseleave', () => autoplayInterval = setInterval(moveNext, 3000));
});


  } catch(e) { console.error(e); }
})();
})();
